import { useCallback, useEffect, useState } from "react";

const getSize = (isClient: boolean) => ({
  width: isClient ? window.innerWidth : undefined,
  height: isClient ? window.innerHeight : undefined,
});

export const useWindowSize = () => {
  const isClient = typeof window === "object";

  const [windowSize, setWindowSize] = useState(getSize(isClient));

  const handleResize = useCallback(() => setWindowSize(getSize(isClient)), [
    isClient,
  ]);

  useEffect(() => {
    if (!isClient) {
      return;
    }

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, [isClient, handleResize]);
  // Empty array ensures that effect is only run on mount and unmount
  return windowSize;
};
